const operatorCodes = ['0424', '0414', '0412', '0416'];

export function validateOperatorCode(code: string): boolean {
  const phoneCode = code.substring(0, 4);
  return operatorCodes.includes(phoneCode);
}
